import PsychologyIcon from '@mui/icons-material/Psychology';
import { useEffect, useState } from 'react';

import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import CodeIcon from '@mui/icons-material/Code';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import GoogleIcon from '@mui/icons-material/Google';
import BusinessIcon from '@mui/icons-material/Business';
import { getSupportStatus } from '../../../services/supportChannel/getsupportstatus';
import { getNavBarOnboardConfig } from '../../../services/whatsapp/getNavBarOnboardConfig';
import { getPartnerRole } from '../../../services/user/getPartnerRole';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { useStartDemo } from '../../../hooks/useStartDemo';
// components
import SvgColor from '../../../components/svg-color';

const icon = (name) => <SvgColor src={`/assets/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  users: icon('users'),
  whatsApp: icon('whatsApp'),
  partners: icon('partners'),
  accountSetup: icon('accountSetup'),
  reports: icon('reports'),
  whitelable: icon('whitelable-setup'),
  profile: icon('profile'),
  Gmb: icon('gmb'),
  notifications: <NotificationsNoneOutlinedIcon fontSize="large" />,
  billing: <PaidOutlinedIcon fontSize="medium" />,
  coupons: <DiscountOutlinedIcon fontSize="medium" />,
  support: <SupportAgentIcon fontSize="medium" />,
  discoveryCall: <PersonSearchIcon fontSize="medium" />,
  // Gmb: <GoogleIcon fontSize="medium" />,
};

const whatsappDemoUrl = new URL(window.location.href);

const useNavConfig = () => {
  const { startDemo } = useStartDemo();

  const [navConfig, setNavConfig] = useState([]);
  const [elligible, setElligible] = useState(null);
  const [elligibleSupport, setElligibleSupport] = useState(null);
  const [partnerRole, setPartnerRole] = useState(null);

  const [partner_type, setPartner_type] = useState('');

  useEffect(() => {
    const currentPartner = JSON.parse(localStorage.getItem('currentPartner'));
    const p_data = currentPartner?.partner_type;
    if (p_data) {
      setPartner_type(p_data);
    }

    const fetchPartnerRole = async () => {
      try {
        if (currentPartner?._id) {
          const res = await getPartnerRole(currentPartner._id);
          setPartnerRole(res?.role || null);
        }
      } catch (error) {
        console.error('Error fetching partner role:', error);
      }
    };
    fetchPartnerRole();
  }, []);

  useEffect(() => {
    const elligiblityStatus = async () => {
      try {
        const res = await getNavBarOnboardConfig(); // Wait for the promise to resolve
        setElligible(res); // Safely handle cases where `res` or `res.plans` might be undefined
      } catch (error) {
        console.error('Error fetching status:', error);
      }
    };
    elligiblityStatus();
  }, []);

  useEffect(() => {
    const elligiblitySupportStatus = async () => {
      try {
        const res = await getSupportStatus(); // Wait for the promise to resolve
        setElligibleSupport(res); // Safely handle cases where `res` or `res.plans` might be undefined
      } catch (error) {
        console.error('Error fetching status:', error);
      }
    };
    elligiblitySupportStatus();
  }, []);

  useEffect(() => {
    if (partnerRole === 'member' || partnerRole === 'agent') {
      setNavConfig([
        {
          items: [
            {
              title: 'Organizations',
              path: PATH_DASHBOARD.organizations.root,
              icon: <BusinessIcon fontSize="medium" />,
            },
          ],
        },
      ]);
      return;
    }

    const navArr = [
      // GENERAL
      // ----------------------------------------------------------------------
      {
        // subheader: 'general v4.1.0',
        items: [
          { title: 'Customers', path: PATH_DASHBOARD.customers.root, icon: ICONS.users },
          (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
            title: 'Partners',
            path: PATH_DASHBOARD.partners.root,
            icon: ICONS.partners,
          },
          // (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
          //   title: 'Google Workspace',
          //   path: PATH_DASHBOARD.googleWorkspace.root,
          //   icon: <GoogleIcon />,
          //   children: [
          //     {
          //       title: 'Customers',
          //       path: PATH_DASHBOARD.googleWorkspace.customers,
          //     },
          //     {
          //       title: 'Transactions',
          //       path: PATH_DASHBOARD.googleWorkspace.transactions,
          //     },
          //   ],
          // },
          {
            title: 'WhatsApp',
            path: PATH_DASHBOARD.whatsApp.root,
            icon: ICONS.whatsApp,
            children: [
              (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
                title: 'Partners',
                path: PATH_DASHBOARD.whatsApp.partners,
              },
              {
                title: 'Customers',
                path: PATH_DASHBOARD.whatsApp.customers,
              },
              (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
                title: 'Transactions',
                path: PATH_DASHBOARD.whatsApp.transactions,
              },
              (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
                title: 'Analytics',
                path: PATH_DASHBOARD.whatsApp.analytics,
              },
              (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
                title: 'Templates',
                path: PATH_DASHBOARD.whatsApp.templates,
              },
              {
                title: 'Demo',
                path: PATH_DASHBOARD.whatsApp.demo.root,
                children: [
                  {
                    title: 'Start Demo',
                    path: '#whatsapp-start-demo',
                    onNavClick: startDemo,
                  },
                  ...(partner_type === 'whitelabel' || partner_type === 'whitelable'
                    ? [
                        {
                          title: 'Customize Demo',
                          path: PATH_DASHBOARD.whatsApp.demo.customize,
                        },
                        {
                          title: 'Demo Records',
                          path: PATH_DASHBOARD.whatsApp.demo.records,
                        },
                      ]
                    : []),
                ],
              },
              // (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
              //   title: 'Discovery Call Setup',
              //   path: PATH_DASHBOARD.whatsApp.discoverySetup,
              // },

              {
                title: 'Fix Display Name',
                path: PATH_DASHBOARD.whatsApp.fixDisplayName,
              },
              elligible?.status === true && {
                title: 'Onboarding Config',
                path: PATH_DASHBOARD.whatsApp.onboardingConfig,
              },
              // {
              //   title: 'Billing',
              //   path: PATH_DASHBOARD.whatsApp.billing,
              //   children: [
              //     {
              //       title: 'Billing Profile',
              //       path: PATH_DASHBOARD.whatsApp.billingProfile,
              //     },
              //     {
              //       title: 'Billing Payment',
              //       path: PATH_DASHBOARD.whatsApp.billingpayment,
              //     },
              //     {
              //       title: 'Customer Invoice',
              //       path: PATH_DASHBOARD.whatsApp.customerInvoice,
              //     },
              //   ],
              // },
            ],
          },

          {
            title: 'Google My Business',
            path: PATH_DASHBOARD.googleMyBusiness.root,
            icon: ICONS.Gmb,
            children: [
              {
                title: 'Partners',
                path: PATH_DASHBOARD.googleMyBusiness.partners,
              },
              {
                title: 'Customers',
                path: PATH_DASHBOARD.googleMyBusiness.customers,
              },
              {
                title: 'Transactions',
                path: PATH_DASHBOARD.googleMyBusiness.transactions,
              },
              {
                title: 'Transaction Invoice',
                path: PATH_DASHBOARD.googleMyBusiness.transactionInvoice,
              },
              {
                title: 'Setup API Key',
                path: PATH_DASHBOARD.googleMyBusiness.setupApiKey,
              },
            ],
          },

          (whatsappDemoUrl?.hostname === 'partner.emovur.com' ||
            whatsappDemoUrl?.hostname === 'localhost') &&
            (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
              title: 'Discovery Call',
              path: PATH_DASHBOARD.discoveryCall.root,
              icon: ICONS.discoveryCall,

              children: [
                {
                  title: 'Discovery Call List',
                  path: PATH_DASHBOARD.discoveryCall.list,
                },
                {
                  title: 'Discovery Call Setup',
                  path: PATH_DASHBOARD.discoveryCall.discoverySetup,
                },
              ],
            },
          (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
            title: 'Reports',
            path: PATH_DASHBOARD.reports,
            icon: ICONS.reports,
          },
          (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
            title: 'Developer',
            path: PATH_DASHBOARD.developers.root,
            icon: <CodeIcon />,
            children: [
              {
                title: 'API Token',
                path: PATH_DASHBOARD.developers.apitoken,
              },
            ],
          },
          elligibleSupport?.status === true &&
            (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
              title: 'Support Channel',
              path: PATH_DASHBOARD.supportChannel,
              icon: ICONS.support,
            },
        ],
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: 'management',
        items: [
          (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
            title: 'Teams',
            path: PATH_DASHBOARD.teams.root,
            icon: ICONS.users,
          },
          {
            title: 'User Org Management',
            path: PATH_DASHBOARD.superUser,
            icon: ICONS.users,
          },
          // {
          //   title: 'Partner Profile',
          //   path: PATH_DASHBOARD.partnersProfile.root,
          //   icon: ICONS.profile,
          //   children: [
          //     {
          //       title: 'Profile',
          //       path: PATH_DASHBOARD.partnersProfile.partnerProfile,
          //     },
          //     {
          //       title: 'Billing Profile',
          //       path: PATH_DASHBOARD.partnersProfile.billingProfile,
          //     },
          //   ],
          // },
          {
            title: 'Partner Profile',
            path: PATH_DASHBOARD.partners.profile,
            icon: ICONS.profile,
          },
          {
            title: 'Notifications',
            path: PATH_DASHBOARD.notifications,
            icon: ICONS.notifications,
          },
          (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
            title: 'whitelabel',
            path: PATH_DASHBOARD.whitelableConfig,
            icon: ICONS.whitelable,
          },
          (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
            title: 'Billing',
            path: PATH_DASHBOARD.billing,
            icon: ICONS.billing,
          },
          (partner_type === 'whitelabel' || partner_type === 'whitelable') && {
            title: 'Coupons',
            path: PATH_DASHBOARD.coupons.root,
            icon: ICONS.coupons,
          },
          // {
          //   title: 'Lead Setup',
          //   path: PATH_DASHBOARD.leadsetup,
          //   icon: <LeaderboardOutlinedIcon />,
          // },
        ],
      },
    ];

    setNavConfig(navArr);
  }, [elligible?.status, elligibleSupport?.status, partner_type, partnerRole, startDemo]);

  return navConfig;
};

export default useNavConfig;
